module.exports = __webpack_public_path__ + "static/assets/ab489520d630473859477c4c30196481.png";